module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER 3")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“M")])])])]), _vm._v("ayday! Mayday! Mayday! This is the sloop "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’!")])]), _vm._v("”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cole never took his cell phone out sailing with him since he kept a two-way radio on board. More than once, he’d lost his cell in the gulf or gotten it soaked. His handheld radio was waterproof, and he managed it one-handed. Finally, someone answered his call for help.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’, Streamin’,")])]), _vm._v(" this is the U.S. Coast Guard Station, Naples Harbor. I read you, sloop "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’.")])]), _vm._v(" Say your location. Over.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“U.S. Coast Guard, this is the sloop "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’.")])]), _vm._v(" This is Cole DeRoca sailing solo out of Turtle Bay. I put in on Keewadin during the storm, but I’m heading for Naples—Port Royal, I think.” Adrenaline poured through him; he hoped to hell he was making sense. “I have a half-drowned passenger who washed in or swam in on Keewadin. She may have been hit by lightning, too—in and out of consciousness.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’,")])]), _vm._v(" do you have a GPS on board?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No GPS, it’s still thick as pea soup out here. Wait—I see the seawall at Gordon Pass, the rock wall to the south—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Put in just north of the pass. We’ll send an E.R. squad….”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cole dropped the radio and slammed both hands back on the tiller. He fought the rush of inward tide that was trying to smash them into the stone break wall of the pass he’d navigated so many times. The outward flow of the Gordon River here crashed into the rising tide. With the wind, it almost capsized them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He leaned out, away from the hull, using his weight against the lunge and roll of the vessel, wishing he’d had time to get in a trapeze harness. “Come on, baby!” he shouted. His mermaid stirred again, cried out something, but the sloop had to come first now. In these crazy crosscurrents, one wrong move and they’d both be fighting for their lives in the surf. It would be doubtful that he would survive, but Briana would never make it. Above all else, he was desperate to save her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cole gritted his teeth and strained to counterbalance the weight of wind and sail. For one terrifying moment, he actually had to steer the tiller with his foot as he hung on to the wire rigging and mainsheet with his hands. The rope cut into his flesh and made his hand go numb. He felt the cords stand out on the sides of his neck; every bone and sinew and muscle screamed at him as he strained to keep the sloop from making a death roll.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yes! The hull cleared the rocks by about ten yards! He swung "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’")])]), _vm._v(" toward the shore, scrambling back into the boat, and readied himself for the crunch of her prow on sand and shells. He threw himself next to Briana and held her to him as the sloop came to a precarious, jerking halt. Her body hit against his, but he braced them both.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Miraculously, as he clambered out, it seemed the storm had lessened. Maybe he was just getting used to the deluge of stinging rain. No, it seemed to be letting up, the lightning and thunder rolling away inland over the bay and the Glades. It was like being given a prize for surviving his struggle with the sea.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He reached over the woman’s prone form and retrieved his radio. It still worked. He called the coast guard again and told them his position was about six beachfront houses north of Gordon Pass. They assured him they’d called 911 for him and a squad was on the way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“One more thing,” he told the officer on the line. “Tell them this woman is Briana—don’t know her last name—who owns the Two Mermaids Search and Salvage in Turtle Bay, and she mentioned her sister, Daria. If anyone can locate Daria, please let her know about Briana’s accident. I’m not sure, but she might have been out in the water with her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If that’s the case, that Daria or her craft are missing, let us know immediately. Over and out.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Will do,” Cole said, suddenly sounding so weary to himself. “Will—try to,” he muttered to himself as he snapped the radio off and bent over Briana.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He cradled her in his arms across his lap, trying to keep her warm. She opened her eyes once, those hugely dilated gray-green eyes that didn’t seem to see him, and cuddled closer. His insides flip-flopped. It had been a long time since he’d held a woman and longer since she was someone who needed him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It seemed both an eternity and yet too soon when he heard a siren screaming along Gordon Drive. He did not let go of Briana until the medics appeared between two houses and came down on the sand carrying a stretcher. They bent over her to take her vitals and put a needle for a drip in her arm. Cole moved back, then off the sloop to give them room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Several people with houses along the stretch of beach came out into the diminishing rain. A short, elderly man swung a too-small windbreaker around Cole’s shoulders. It was only then he realized he was shaking.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If I go to the hospital with her, could you watch my boat?” Cole asked him. His teeth were chattering from the chill, and nerves.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sure, sure. What happened to her? She your wife?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“A friend.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sure. Beautiful old boat. Don’t worry about a thing. I mean, I’m sure she’ll be fine—the girl and the boat.”")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Manuel Salazar, whom everyone called Manny, slammed the door to his old Ford truck, darted through the last raindrops and unlocked the front door to the Two Mermaids Marine Search and Salvage Shop. His fourteen-year-old daughter, Lucinda, trailed him in, yakking all the way. Lately she talked to her parents only in English. Everyone else in the family was proud to speak in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Español,")])]), _vm._v(" but not Lucinda. He’d laid down the law to her that she was having the traditional "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("quinceañera")])]), _vm._v(" celebration for her fifteenth birthday, a huge party which announced to friends and family that she was entering adulthood. Most "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("chicas")])]), _vm._v(" couldn’t wait for that celebration, which was better than any American birthday or sweet-sixteen party, but not his daughter. Lucinda had suddenly gone from being his angelic, younger daughter to someone he didn’t even know.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He walked to his desk to see if there were any phone messages. Nada. With this storm, he wondered where the shop’s dive boat, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Mermaids II,")])]), _vm._v(" had ended up. His stomach knotted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But it’s so expensive, Papa. Think of all you and Mama could do with the money.” Lucinda tried another tack to win her argument. “I overheard you say to her you couldn’t afford it, that you’d have to find a way, but why should you?” Dark eyes flashing in her pert, round face, she stood with hands on her hips, glaring at him. She looked so much like his sainted mother sometimes, though his mother would never have been caught dead in torn jeans and skinny-strap top that showed too much skin. “My friends—my American friends—” she plunged on, “think it’s really old-fashioned.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So, they not your friends then, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("sí? Caramba,")])]), _vm._v(" don’t you look down on your Latina friends. I never know a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("chica")])]), _vm._v(" crazy enough pass up a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("quinceañera!")])]), _vm._v(" Your Latina friends all happy ’bout their parties, dance with boys, make parents, godparents and "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("padrinas")])]), _vm._v(" happy, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("sí?")])]), _vm._v(" And you just ask your Americana friends, what ’bout ethnic diversity and all that?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Man, you go from sounding like a shrink to priest to politician, Papa. I’m an American teenager, and they have some say in their lives. Sure, most "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("chicas")])]), _vm._v(" want a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("quinceañera")])]), _vm._v(" party, but not me! You want to spend some money for me you don’t have, how ’bout a new car I could use to get a job in town when I’m sixteen—that’s the age Americans look forward to.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No car! Tell your American friends don’t come if they don’t want a good time with Mexican dancing and food and—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I can’t even talk to you and Mama anymore!” she exploded, smacking her hands on her thighs. “Carianna didn’t have to have one!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Have")])]), _vm._v(" to have one? Your older sister give anything, if we could have pay for party for her, invite all our friends and family. But now I got this job with Briana and Daria. They even be "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("padrinas,")])]), _vm._v(" help us pay for things—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So it’s a party for them? No, this whole thing’s for you and Mama, even Carianna and Grandmama Rosa, not for me!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Me, me, me!” he mocked, throwing up his hands. “Now that what an American teenager all about! When your mama and I was your age—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not you and Mama, and I don’t still have one foot in the great country of Mexico where we were all starving! Why can’t you just listen?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You shut your mouth, American girl! You gonna have "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("quinceañera,")])]), _vm._v(" honor your mama and grandmama. You make your family proud or you gonna find a new family. Now sit there till I find that video camera.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She turned her back and flopped into the padded chair at Bree’s desk. Muttering under his breath, Manny walked out of the small office space into the large, concrete-floored back room where dive and rescue gear was stored. A sign over the doorway read The Water is Our Office, and on the far wall hung a blown-up poster of the twins in their mermaid wet suits with scuba tanks at their feet and the words Love That Bottled Air! Another large picture at the back of the room showed only the twins’ mermaid tails as they dove below the surface and read, Bottoms Up!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wall Peg-Boards displayed depth charts, diagrams of the various artificial wrecks in this area of the gulf, and handmade drawings of the precious turtle sea grass the twins tended out by the Trade Wreck. On the floor, separated by aisles to walk between, were gears, winches, capstans, marker buoys, metal detectors, lift bags, underwater lights, pelican floats, wreck reels, cutting tools and cameras.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His area was toward the back of the shop, where the heaviest equipment—especially anything to do with motors—was stored. Manny also handled in-water ship repairs and serviced dive equipment. He had a deal with the twins that he didn’t dive with tanks, only shallow stuff with a snorkel. Too far under water and he went nuts—“claustro-hydrophobic,” Daria had labeled it. Still, he loved the look of this place, the very smell of it. His greatest goal in life was to own the business someday and run it his way. He’d take on the rival salvage company across the bay and, once and for all, shut up its big brute of an owner, Sam Travers. You’d think that since Travers also did industrial dredging, demolition and pile driving, he’d leave the lighter stuff to Two Mermaids, but Sam resented the twins, especially Bree.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This big back room always looked like organized confusion, much, Manny thought, like his employers’ busy lives. How he envied them for building this business, though he’d helped too and thought he was worth more than they paid him. But he’d recently found out that he would inherit half of the shop if anything happened to either of them, and since then, he’d made some big, hard decisions.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Caramba,")])]), _vm._v(" he might even have to force himself to dive to get what he wanted, instead of just operating on the surface. He grunted as his eyes searched for the camera to film the inside of the big, fancy Garcia Party House he had rented for the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("quinceañera.")])]), _vm._v(" He wanted to show his "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("madre")])]), _vm._v(" how good things were going before cancer took her. She’d given up so much for him. He had to make her proud of him before she died, whatever it cost.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He found the camera and took it out of its plastic underwater casing and rejoined Lucinda, who was twirling herself dizzy in Bree’s chair. Finally, his "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("chica")])]), _vm._v(" had shut her mouth. But in a way, the silence got to him, because he had to be doing something to keep himself from going loco waiting to hear about Bree and Daria.")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("For once, Amelia Westcott was glad to see her own driveway. She hated driving in the rain, hated these months of weather so hot and humid you had to run from AC to AC. At least her sons would not be home from Cub Scouts yet and she could take a cool shower and calm down before they showed up. Her meeting with Daria had been disastrous; later, the docent’s tea at the art gallery had gone on much longer than she’d expected, partly because the lights had gone out from that boomer of a storm. Ah, sometime this month or next, the weather would clear and she could breathe again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If she hadn’t married Ben, who was now the prominent and very busy prosecuting attorney of Collier County, she probably would have moved north to the Carolinas. It might have helped her escape painful memories of her youth in this area. She did love Ben and their lifestyle here, and she was very proud of her husband, although sometimes she wished she had a career—a cause—of her own that would "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("really")])]), _vm._v(" help other people, something that mattered more than her committees, however philanthropic their purposes and however much they helped promote Ben’s career. Then she could look beyond these very luxurious four walls and the messes her boys made. A stay-at-home mom who didn’t want to stay at home, that was her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The moment Amelia closed the garage door and went into the house, she heard her message-waiting beeper. Maybe the day had been changed for the Clear the Gulf Commission meeting tomorrow. At least her membership on that had made Bree and Daria admit she was good for something, though it was Florida Congressman Josh Austin who had suggested them for oversight of the sea grass and marine life report.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You have one messages,” the recorded voice told her when she pressed the play button. With all the world’s modern technology, why couldn’t they teach a digital chip good grammar? Heaven knows, her laptop underlined every darn spelling and grammar error she made in the numerous letters to the editor she wrote.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“This important message is for Amelia Devon Westcott,” the recorded woman’s voice said. Amelia’s stomach went into free fall. She never used her maiden name. “One of our E.R. doctors mentioned you’re on our fund-raising guild committee here at the hospital, so that’s how we traced you. Mrs. Westcott, I’m calling because your sister—we believe it is Briana Devon…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Briana,")])]), _vm._v(" Amelia thought. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Not Daria?")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“…has been brought by emergency squad to Naples Hospital from an accident out in the gulf, and we’re hoping you could come into the E.R. to identify her and be with her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bree! Bree? An accident? Identify her? Were they trying to break the news to her that Bree was dead? It couldn’t be—couldn’t be Bree!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The voice went on, “We have been informed that she lives with another sister, but no one at Briana and Daria Devon’s place of employment and residence knows where Daria is, so we have been unable to reach her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As if she were speaking to a real woman, Amelia whispered, “I’ve never been able to reach either of them, no matter how hard—how "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("desperately")])]), _vm._v("—I tried.”")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Cole paced the E.R. waiting room like an expectant father. He knew he looked like hell, still in soaked shorts, sopping shoes that squeaked when he walked and a borrowed windbreaker that was so small he couldn’t even zip it. The distractions of people in trouble here unnerved him, too: a distraught mother with a kid who’d swallowed a quarter; a young man in terrible pain evidently waiting to be admitted to pass a kidney stone; elderly people who looked like death warmed over. The place was packed, but at least they’d taken Briana back through the swinging doors into the depths of curtained alcoves right away. He’d already bugged the triage nurse more than once. Why didn’t they come tell him something?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This sent him back to the terrible night of his dad’s sudden heart attack. He’d known his father was dead, but he’d called an ambulance. Rather than pronounce him dead at home, they’d done CPR and rushed him to the E.R. in Sarasota, only to tell Cole what he already knew. But Briana had to be all right. She was strong to have lasted out in that brutal gulf, evidently swimming with sharks, too. Cole had practically forced his way into the E.R. vehicle, but they’d shut him out here.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Shut out—the story of his life since his divorce last year from Jillian. He hadn’t realized until she cut him off from their friends—or those he thought were their friends, but were really hers—that he’d given up too much of his own world for hers. It hadn’t helped his client list to have his social contacts shrink like that. At least it had given him an excuse to quit playing country club games. But what he’d learned most from the biggest mistake of his life was that, after two years of their marriage, Jillian had not really been an integral part of him. He just didn’t miss her. He felt sad and bad their marriage had failed, but he didn’t feel her loss. Strangely, he’d feel worse if Briana were lost, and he’d only spent one lunch months ago and then this horrible day with her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was surprised to see Amelia Westcott, a woman he served with on the Clear the Gulf Commission, rush in the double glass doors and head for the triage nurse at the front desk.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You called and told me to come right in,” Amelia said. She was out of breath, but her voice carried clearly. “I’m Briana Devon’s sister. But is her other sister, her twin Daria, here yet?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cole went over. “Amelia, I didn’t know you were Briana’s sister—I mean I don’t know why I would—but I’m the one who found her half-drowned on the beach at Keewadin Island and brought her in—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Half-drowned? I’ll bet she was with Daria. She’s always with Daria on some sea search, some underwater mission. I can’t believe they were out in that storm.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Though he could tell she was concerned, she spoke with an undercurrent of bitterness. The older he got, the more he saw family problems everywhere, though most simmered just below the surface of people’s daily lives. He used to think his messed-up family was unique, but now he knew it was almost normal.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The triage nurse was on the phone, checking on Briana’s status. Finally, some answers, Cole thought. He stuck tight to Amelia while she folded her arms and seemed to collapse within herself. She was a good-looking woman, a platinum blonde with every hair in place and icy blue eyes, in contrast to Briana’s natural auburn hair and gray-green eyes. Even now, Amelia looked perfectly put together, with makeup worthy of a photo shoot, while the few times he’d seen the twins around they’d seemed windblown and often wet—a sexy combination. Amelia was obviously older than the twins and, he guessed, uptight by nature as well as from the situation. Rather than taking a deep breath, even when he urged her to, Amelia narrowed her eyes and breathed out through flared nostrils as if she were a bull waiting to charge. That reminded him about the bull sharks, but he decided not to spring that on her, at least not yet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It wasn’t long before a thin, balding doctor came out and went straight for Amelia. The man—his badge said Dr. Micah Hawkins—flipped through papers on his clipboard and asked, “Mrs. Westcott, you are next of kin for Briana Devon?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cole felt his knees go weak. Had Briana died? She couldn’t have died!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, her sister—one of them,” Amelia said as the doctor gestured her to walk with him. Cole kept right up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She swallowed a lot of water, but worse, we believe she’s been struck by lightning while in the gulf and that can lead to complications. And you are?” Dr. Hawkins asked, squinting at Cole.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Cole DeRoca, the friend who found her and brought her in. I gave her mouth-to-mouth and got her breathing again. She’s going to be all right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You are to be commended, Mr. DeRoca—you probably saved her life. If Mrs. Westcott doesn’t mind, you can come along. We’ll need to run a battery of tests, call in a neuropsychologist. She keeps slipping in and out of consciousness and asking for Daria.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh, she would,” Amelia said. “But, you mean Daria hasn’t been found?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s her twin sister. Briana was evidently out in a boat with her,” Cole explained to the doctor. “But Briana must have fallen in.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Dear God, Daria can’t be missing—out there, too,” Amelia cried, gripping Dr. Hawkins’s wrist. “Doctor, call in whatever specialists you need. I’m not sure about Briana’s insurance, but I’ll take care of all that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cole’s dislike for Amelia softened a bit. But when she said nothing else, as he followed the two of them deeper into the maze of curtained cubicles, he asked, “But if Briana was out in the gulf with Daria, where is Daria now?”")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Was she dead? Briana wondered. She slitted her eyes open, just barely, trying to keep the bright lights out of her dark brain. She felt loggy, helpless, at the mercy of the sliding, shifting sea. Up, down, all around…But the sky looked whiter now, too bright, one big cloud floating over her with more than one sun in it. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Ceiling lights.")])]), _vm._v(" They hurt her eyes, and even when people spoke across the room, it seemed they shouted at her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("People’s faces, unfamiliar, swam in and out above her. The sharks were gone. Had they been real? Daria, her mirror image, where was she? She didn’t like to dive alone, she wanted Daria, her other self, there when they stepped together through the looking glass into the wonderland of the deep.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Someone forced her eyelids apart and shone a bright light into the depths of her brain. She jerked away. She tried to lift her hands to shield her face, but one of her arms was heavy with tubes and the other was bandaged and hurt like heck. A man—a doctor—leaned over her. Oh, Amelia was standing beside him. Why was Amelia here? And who was the tall, handsome man with dark eyes and black hair, his face so worried as he looked her over? His clothes showed he was not another doctor. Had he been swimming with her?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What happened?” she tried to ask, but she didn’t sound like herself and no one answered. What was the matter with these people? And where was Daria?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She sustained no burns except on her left wrist, where she wore a stainless-steel dive watch,” the doctor was telling Amelia and the man. “Actually, it’s probably a skin lesion—an inflammatory response—which may disappear in a few days. I’ve already ordered a CT scan and an MRI, and we’ll have her in a room as soon as possible, so we can monitor her better. We’ll do some functional scans but call in a specialist for that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Functional—function of the brain?” the man asked, his deep voice a soothing whisper compared to the others.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Precisely. Aftereffects can vary widely. And although her pupils are dilated, I want to assure you that does not necessarily mean brain injury, Mrs. Westcott.” He leaned closer, very close. “Briana, I’m Dr. Hawkins. Can you hear me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She could hear him, all right. She heard every sound in this place, even the dripping of that bag above into her tube. “Yes,” she said with great effort, because she didn’t think she had the strength to nod. Her lips felt stiff and cracked. “Where’s Daria?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The tall man spoke again. “Brianna, can you tell us where you last saw Daria?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She fought to form her words. They had to help find Daria.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“When I dove—off our boat—at Trade Wreck—before the storm.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Amelia gasped, a sound that pierced Bree’s eardrums. “You mean she could be lost at sea?” her sister demanded, but the man put his hand on Amelia’s arm to keep her quiet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Was she still on the boat when you saw her last?” he asked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes. Yes!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then she’ll be all right,” Amelia said. “She probably had to ride out the storm, or put in somewhere else.” She squeezed Bree’s shoulder and moved away with the doctor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("No,")])]), _vm._v(" Bree wanted to scream. Didn’t they know Daria never would have left her? Not of her own accord.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We’ll look for her and find her,” the tall man said, and put his big hand lightly on her shoulder where Amelia’s had just been. His hand was warm, solid. Where had she seen him before? “Just try to rest now,” he said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If Amelia and the doctor thought they were whispering when they moved away, she heard them anyway. The doctor was saying that a lightning strike near her in the water—a side flash—must have given her a concussion. He told Amelia she might have sporadic amnesia or become moody, distracted, irritable or forgetful.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Exhausted as she was, Bree vowed never to forget what had happened to Daria. But what "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" happened? At least that man said he would help. He said “we” would find Daria. She should know who he was, but she could not recall. She felt both fearful and furious, so the doctor must be right about her moods, but she could not have amnesia, not about Daria.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Though Bree was afraid if she closed her eyes again she’d see the horror of the sea, the sharks, she pressed her eyelids tightly closed. Amazing how these bright lights hurt her eyes and how she could hear even the shuffle of the nurses’ feet on the floors. Other people’s voices and moans, cries of pain. Was she really hearing those or were they deep inside her?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The occasional screech of the curtains’ rings across the metal rods almost deafened her. She could hear the man ask Amelia for her cell phone and then take it outside the curtain to make a call to the coast guard to tell them about Daria and their dive boat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Exhausted, sick, she felt so strange, but Bree knew then what she had to do, even if that man had promised to look for Daria, even if he was calling for help. When Amelia and the doctor weren’t looking, she had to get out of this bed, get another boat and go find her sister somewhere out on the dark, devouring sea.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec489e22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/belowthesurface_ch03.vue
// module id = 72
// module chunks = 0